import React, { useEffect, useState } from 'react';
import { Drawer, Link, Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ModalHeader from '@/components/Header/Modal';
import useTable from '@/hooks/useTable';
import { getConsumerGroupDetailList } from '@/services/kopConsumerGroupService';
import { renderNum, renderNumRate } from '@/utils/common';
import PermWrapper from '@/components/PermWrapper';
import InnerTable from './InnerTable';
import ResetOffsetModal from './ResetOffsetModal';

function Detail({ consumerGroupName, clusterName }) {
  const [visible, setVisible] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const onResetOffset = (row) => {
    setCurrentRow(row);
    setResetVisible(true);
  };

  const columns = [
    {
      title: 'Topic名称',
      colKey: 'consumedTopicName',
    },
    {
      title: 'Status',
      colKey: 'status',
      width: 100,
    },
    {
      title: 'Max Lag',
      colKey: 'maxLag',
      width: 100,
      cell: renderNum,
    },
    {
      title: '消费速率',
      colKey: 'totalTopicBytesOut',
      cell: renderNumRate,
      width: 110,
    },
    {
      title: 'Member数',
      colKey: 'memberSize',
      width: 110,
      cell: renderNum,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        // 防误触
        <div onClick={(e) => e.stopPropagation()}>
          <PermWrapper resource='kop:consumer-group:reset-offset'>
            <Link theme='primary' hover='color' onClick={() => onResetOffset(row)}>
              重置Offset
            </Link>
          </PermWrapper>
        </div>
      ),
      width: 120,
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getConsumerGroupDetailList({
      ...params,
      clusterName,
      consumerGroupName,
    });
    setData(data);
  });

  const { header, setData, doSearch, config, doRefresh } = useTable({
    columns,
    onSearch: loadData,
  });

  useEffect(() => {
    if (visible) {
      doSearch();
    }
  }, [doSearch, visible]);

  const handleClose = (refresh) => {
    setCurrentRow(null);
    setResetVisible(false);
    if (refresh) {
      doRefresh();
    }
  };

  const expandedRow = ({ row }) => (
    <InnerTable detail={{ ...row, consumerGroupName, clusterName }} />
  );

  return (
    <>
      <Link theme='primary' style={{ wordBreak: 'break-all' }} onClick={() => setVisible(true)}>
        {consumerGroupName}
      </Link>
      <Drawer
        size={'80%'}
        visible={visible}
        destroyOnClose
        onClose={() => setVisible(false)}
        footer={null}
        header={<ModalHeader tags={[clusterName, consumerGroupName]}>ConsumerGroup</ModalHeader>}
      >
        <Root>
          {header}
          <Table
            {...config}
            expandedRow={expandedRow}
            expandOnRowClick
            rowKey='consumedTopicName'
          />
          <ResetOffsetModal
            visible={resetVisible}
            detail={{ ...currentRow, clusterName, consumerGroupName, partition: -1 }}
            doClose={handleClose}
          />
        </Root>
      </Drawer>
    </>
  );
}

export default connect((state) => ({
  perms: state.auth.perms,
}))(Detail);

const Root = styled.div`
  .t-table__row-full-element {
    padding: 0;
  }
`;
